import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiTabs: Overrides['MuiTabs'] = {
  root: {
    borderBottom: `1px solid ${pallete.grey[500]}`,
    textTransform: 'none',
    color: `${pallete.common.black}`,
  },
  indicator: {
    borderBottom: `3px solid ${pallete.primary.dark}`,
  },
};

export default MuiTabs;
